import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

const SYSTEM_IMAGE = "/pickle-wall-professional-system.png";
const PRO48_IMAGE =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_pickle-trainer-v1/artifacts/q7ez005c_17A28E49-9419-43E4-BEA3-1A862D0F5223.png";
const HOODIE_IMAGE =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_pickle-trainer-v1/artifacts/x2orvpgy_IMG_2233.jpeg";
const ACADEMY_IMAGE = "/pickle-wall-academy-tryouts.png";

const cards = [
  {
    id: "training-systems",
    title: "Training Systems",
    tag: "Starting at $249",
    image: SYSTEM_IMAGE,
    alt: "Pickle Wall™ training net and backpack, official product photography",
    to: "/shop",
    fit: "cover",
  },
  {
    id: "pro-48",
    title: "PRO 48",
    tag: "Pickle Wall outdoor pickleballs",
    image: PRO48_IMAGE,
    alt: "Pickle Wall™ PRO 48 Outdoor Pickleballs packaging with ATP ZONE branding",
    to: "/shop",
    fit: "contain",
  },
  {
    id: "atp-zone",
    title: "ATP ZONE",
    tag: "Precision drives progress.",
    image: SYSTEM_IMAGE,
    alt: "ATP ZONE training markings on the Pickle Wall™ net",
    to: "/shop",
    fit: "cover",
  },
  {
    id: "apparel",
    title: "Apparel",
    tag: "Pickle Wall performance gear",
    image: HOODIE_IMAGE,
    alt: "Pickle Wall™ Performance Hoodie, official product photography",
    to: "/shop",
    fit: "contain",
  },
  {
    id: "academy",
    title: "Pickle Wall Academy",
    tag: "Youth development & structured training",
    image: ACADEMY_IMAGE,
    alt: "Pickle Wall™ Academy training session",
    to: "/academy",
    fit: "cover",
  },
];

export default function Ecosystem() {
  return (
    <section id="ecosystem" className="relative py-24 md:py-36 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#FF6B00] mb-4">The Ecosystem</div>
        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-black uppercase tracking-tight text-balance max-w-3xl">
          More Than <span className="text-[#FF6B00]">A Net.</span>
        </h2>
        <p className="mt-5 text-lg text-white/65 max-w-2xl">
          Pickle Wall is building a training ecosystem around players, repetition, equipment and development.
        </p>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {cards.map((c) => (
            <Link
              key={c.id}
              to={c.to}
              data-testid={`ecosystem-card-${c.id}`}
              onClick={() => trackEvent("navigation_click", { button_text: c.title, button_location: "home-ecosystem" })}
              className="group relative rounded-2xl overflow-hidden border border-white/10 bg-[#111] hover:border-[#FF6B00]/50 transition-all"
            >
              <div className="aspect-square w-full overflow-hidden bg-[#0a0a0a]">
                <img
                  src={c.image}
                  alt={c.alt}
                  loading="lazy"
                  className={`w-full h-full ${c.fit === "contain" ? "object-contain" : "object-cover"} group-hover:scale-105 transition-transform duration-500`}
                />
              </div>
              <div className="p-4">
                <div className="flex items-center justify-between">
                  <h3 className="font-display font-black uppercase tracking-tight text-base">{c.title}</h3>
                  <ArrowUpRight size={16} className="text-[#FF6B00] shrink-0" />
                </div>
                <p className="mt-1 text-xs text-white/50">{c.tag}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
